var map = {
	"./BasicComputerFamiliarization.jpg": "3981",
	"./BasicSafetyFamiliarization.jpg": "949c",
	"./ComputerBasedTraining.jpg": "7401",
	"./ComputerTroubleshooting.jpg": "170d",
	"./ControlEngineering.jpg": "7c7b",
	"./GlobalMaritime_DistressAndSafetySystem.jpg": "227d",
	"./HydraulicsPneumatic.jpg": "2a54",
	"./InternationalSafetyManagement.jpg": "ea13",
	"./MaritimeElectroTechnology.jpg": "7e1f",
	"./ShipSecurityAwareness.jpg": "408b",
	"./TankerSafetyAndVetting.jpg": "3ebb",
	"./VoyagePlanning.jpg": "4d55"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0236";